'use client';
import { List, SearchIndexCourseFilters } from '@shared/types';
import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, useState, useContext, useMemo } from 'react';
import { EducatorCourseSearch } from '../../../../../components/EducatorCourseSearch';
import { CollectionsFilters } from '../../../../../components/EducatorCourseSearch/CollectionsFilters';
import { CourseResults } from '../../../../../components/EducatorCourseSearch/CourseResults';
import { EducatorCoursesSchema } from '../../../../../components/EducatorCourseSearch/EducatorCoursesSchema';
import { LoadMoreButton } from '../../../../../components/EducatorCourseSearch/LoadMoreButton';
import { SearchError } from '../../../../../components/EducatorCourseSearch/SearchError';
import { useSearchEducatorProps } from '../../../../../services/search/searchEducator/useSearchEducator';
import styles from './styles.module.scss';
import { SearchIndexSortBy } from '../../../../../services/search/shared';
import { SearchBar } from '../../../../../components/EducatorCourseSearch/SearchBar';
import { CourseSearchContext } from '../../../../../components/EducatorCourseSearch/CourseSearchContext';

const ConditionalSearchBar: FunctionComponent = () => {
    const { courses, searchTerm } = useContext(CourseSearchContext);

    const hasSearchTerm = useMemo(() => {
        return searchTerm && searchTerm.length > 0;
    }, [searchTerm]);

    if (courses.length <= 6 && !hasSearchTerm) {
        return null;
    }

    return <SearchBar />;
};

type CoursesProps = {
    educator: PublicEducator;
    lists: Array<List>;
    layout: 'grid' | 'rows' | 'datedRows';
    initialResults: NonNullable<useSearchEducatorProps['initialResults']>;
    sort?: SearchIndexSortBy;
};
export const Courses: FunctionComponent<CoursesProps> = ({
    educator,
    lists,
    layout,
    initialResults,
    sort,
}) => {
    const [filters, setFilters] = useState<SearchIndexCourseFilters>({ context: 'minisite' });
    const [search, setSearch] = useState('');

    return (
        <div className={styles.courses}>
            <EducatorCourseSearch
                filters={filters}
                setFilters={setFilters}
                searchTerm={search}
                setSearchTerm={setSearch}
                educator={educator}
                initialResults={initialResults}
                sort={sort}
            >
                <EducatorCoursesSchema />
                <CollectionsFilters educator={educator} lists={lists} />
                <ConditionalSearchBar />
                <SearchError />
                <CourseResults educator={educator} displayAs={layout} />
                <LoadMoreButton />
                <SearchError />
            </EducatorCourseSearch>
        </div>
    );
};
